import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-custom-tag',
  imports: [],
  host: {
    class:
      'text-xs text-text-primary inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-full px-2.5 py-0.5 font-medium align-middle',
    '[style.background-color]': 'bgColor()',
    '[title]': 'label()'
  },
  template: `
    <span class="size-1.5 shrink-0 rounded-full" [style.background-color]="color()"></span>
    <span class="min-w-0 truncate">{{ label() }}</span>
  `,
  styles: ``
})
export class CustomTagComponent {
  /** Full-strength tag color as any CSS color (typically a #hex). Drives the dot and the soft background. */
  color = input.required<string>();
  label = input.required<string>();

  /**
   * Soft background: ~14% tint of the color over whatever is behind it, so it
   * reads correctly in both light and dark themes without a per-theme value.
   */
  protected bgColor = computed(
    () => `color-mix(in srgb, ${this.color()} 14%, transparent)`
  );
}
